const disasters: Mapping[] = [
  {
    label: '地震',
    value: 0,
  },
  {
    label: '台風',
    value: 1,
  },
  {
    label: '洪水',
    value: 2,
  },
  {
    label: '噴火',
    value: 3,
  },
  {
    label: '感染症',
    value: 4,
  },
];

export default disasters;
